import React, { Component } from 'react';
import AboutUsView from './AboutUsView';
import { url } from '../../Server/url/GlobalUrl';

class AboutUsComponent extends Component {
  state = {
    modal_show: false,
    team_member: [],
    about_us: '',
    what_make_us_different: '',
    what_make_us_different_item: [],
    what_make_differences: [],
  };

  hideCalculator = () => {
    this.setState({ modal_show: false });
  };

  showCalculator = () => {
    this.setState({ modal_show: true });
  };

  componentDidMount() {
    console.log('url', url);
    fetch(url + '/api/team/', {
      method: 'GET',
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('result', result);
          this.setState({ team_member: result });
          console.log('result', this.state.team_member);
        },
        (error) => {
          console.log('error', error);
        }
      );
    fetch(url + '/cms/about-us/?title=About Us', {
      method: 'GET',
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.length > 0) {
            console.log('result-about-us', result);
            this.setState({ about_us: result[0] });
          }
        },
        (error) => {
          console.log('error', error);
        }
      );
    fetch(url + '/cms/about-us/?title=What Makes Us Different?', {
      method: 'GET',
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.length > 0) {
            console.log('result-about-us', result);
            this.setState({ what_make_us_different: result[0] });
            this.setState({
              what_make_differences: result[0].what_make_differences,
            });
          }
        },
        (error) => {
          console.log('error', error);
        }
      );
  }

  render() {
    return (
      <AboutUsView
        modal_show={this.state.modal_show}
        team_member={this.state.team_member}
        showCalculator={this.showCalculator}
        hideCalculator={this.hideCalculator}
        about_us={this.state.about_us}
        what_make_us_different={this.state.what_make_us_different}
        what_make_differences={this.state.what_make_differences}
      />
    );
  }
}

export default AboutUsComponent;
